/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    PaydayGameData,
    PaydayInitData,
} from "./PaydayData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {Payday} from "../Payday";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

// first attempt at doing big symbols, probably not a very good one :joy:
export interface reelPosition {
    reelID:number,
    reelPosition:number
}

export class PaydayModel extends GameModel<PaydayInitData, PaydayGameData> {

    public isRestore:boolean = false;
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public totalWin:number;
    public winRatio:number;
    public totalWinRatio:number;
    public isGodMode:boolean;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        Payday.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < Payday.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Payday.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                } else if (this.data.nextMode == GameMode.NORMAL) {
                    this.buyFeatureName = "";
                }
            }
        });

        Payday.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < Payday.model.initData.featureBuyTimesBetValue.length; index++) {
                if (Payday.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                } else if (this.data.nextMode == GameMode.NORMAL) {
                    this.buyFeatureName = "";
                }
            }
        });

        Payday.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, () => {
            const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
            if (activeBetFeature?.name == "CLAW_3" || activeBetFeature?.name == "CLAW_3_FREESPIN") {
                Payday.reelView.setToThreeClaws();
            } else if (activeBetFeature?.name == "CLAW_5" || activeBetFeature?.name == "CLAW_5_FREESPIN") {
                Payday.reelView.setToFiveClaws();
            } else {
                Payday.reelView.setToOneClaw();
            }

        })


    }

    protected onInit(data:PaydayInitData):void {
        console.log("INIT DATA", data);
        super.onInit(data);
        this.isRestore = data.isRestoreState;
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
    }

    public onGame(data:PaydayGameData):void {
        console.log("GAME DATA", data);
        super.onGame(data);
        this.isRestore = false;
        this.totalWin = this.gameData.accumulatedRoundWin;
        //this.winRatio = this.gameData.thisResponseWinnings / Outsourced.getBetPrice();
        this.winRatio = this.gameData.thisResponseWinnings / this.gameData.playedBetValue;
        this.totalWinRatio = Math.round(this.data.accumulatedRoundWin / this.gameData.playedBetValue);
        this.isGodMode = this.buyFeatureName == "GOD_MODE" && this.data.wasFeatureBuy;
    }

    public isBoostedBet():boolean {
        return SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature()?.type == "BOOSTED_BET";
    }

    public isFreespins():boolean {
        return this.data.mode == GameMode.FREESPIN || this.data.nextMode == GameMode.FREESPIN;
    }

    public winningIndices() {
        return this.data.clawPositions
            .filter((clawIndex) => this.data.successfulClaws[clawIndex] &&
                                   this.data.reels[clawIndex] != "SC")
            .map((clawIndex) => clawIndex - 2);
    }

    public scatterIndices() {
        return this.data.clawPositions
            .filter((clawIndex) => this.data.successfulClaws[clawIndex] &&
                                   this.data.reels[clawIndex] == "SC")
            .map((clawIndex) => clawIndex - 2);
    }

    public succesfulClaws() {
        return this.data.clawPositions.map((clawIndex) => this.data.successfulClaws[clawIndex]);
    }

    public clawIndices() {
        return this.data.clawPositions.map((claw) => claw - 2);
    }

    specialWinThresholds():boolean {
        return false;
        //return this.data.wasFeatureBuy ||
        //    this.data.boostedBet &&
        //    this.buyFeatureName != "BOOSTED_BET" &&
        //    this.initData.featureBuyTimesBetValue.find((feature:{name:string}) => feature.name == this.buyFeatureName)!.price > 20;
            // max win och 5000 with 250x win as threshold for highest level, meaning we wont ever be able to reach it
            // if the bet is base bet x20 or higher in cost
    }
}